module.exports = __webpack_public_path__ + "media/winter_2025_sweepstakes/member-45abdc56.svg";